import React, { useState, useEffect } from "react";
import moment from "moment";
import minimize from "../../../../../assets/minimize.svg";
import upload from "../../../../../assets/upload.svg";
import ImageUploader from "./Uploader";
import { ENDPOINT } from "../../../../../constants";
import {
  Input,
  Modal,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  Icon,
  message,
  Upload,
  Table,
  Divider,
  Popconfirm,
} from "antd";
import { platformApi } from "../../../../../api";
import "./index.less";
import { add } from "lodash";
import Title from "antd/lib/skeleton/Title";
const { Option } = Select;
const { Item } = Form;

let urls = ENDPOINT;

const InsuranceForm = ({
  form,
  insModal,
  setData,
  setInsModal,
  formData,
  insuranceData,
  setFormData,
  dataSource,
  setDataSource,
  editable,
  // modifyData,
  removedData,
  setRemovedData,
  setUploading,
  uploading,
  idOfVehicle,
}) => {
  const {
    getFieldDecorator,
    setFieldsValue,
    getFieldValue,
    validateFields,
  } = form;
  const [formDataList, setFormDataList] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [pdf, setPdf] = useState(false);
  const [insurancePair, setInsurancePair] = useState({});
  const [PDFdata, setPDFdata] = useState(null);
  const [url, setUrl] = useState();
  const [visiblePDF, setVisiblePDF] = useState(false);
  // const [uploading, setUploading] = useState(false)
  const [newData, setNewData] = useState([]);
  const [bulkUploads, setBulkUploads] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [required, setRequired] = useState(false);
  const [modifyData, setModifyData] = useState([]);
  const [addressProofFileList, setAddressProofFileList] = useState([]);
  const [addressProofUrl, setAddressProofUrl] = useState(null);

  const [chassisFileList, setChassisFileList] = useState([]);
  const [chassisUrl, setChassisUrl] = useState(null);

  const [form22FileList, setForm22FileList] = useState([]);
  const [form22Url, setForm22Url] = useState(null);

  const [form21FileList, setForm21FileList] = useState([]);
  const [form21Url, setForm21Url] = useState(null);

  const [SignatureFileList, setSignatureFileList] = useState([]);
  const [SignatureUrl, setSignatureUrl] = useState(null);
  const [PanCardForm60FileList, setPanCardForm60FileList] = useState([]);
  const [PanCardForm60Url, setPanCardForm60Url] = useState(null);
  const [RightFileList, setRightFileList] = useState([]);
  const [RightUrl, setRightUrl] = useState(null);
  const [LeftFileList, setLeftFileList] = useState([]);
  const [LeftUrl, setLeftUrl] = useState(null);
  const [FrontFileList, setFrontFileList] = useState([]);
  const [FrontUrl, setFrontUrl] = useState(null);
  const [RearFileList, setRearFileList] = useState([]);
  const [RearUrl, setRearUrl] = useState(null);
  const [InvoiceFileList, setInvoiceFileList] = useState([]);
  const [InvoiceUrl, setInvoiceUrl] = useState(null);
  const [DisclaimerFileList, setDisclaimerFileList] = useState([]);
  const [DisclaimerUrl, setDisclaimerUrl] = useState(null);
  const [Form14FileList, setForm14FileList] = useState([]);
  const [Form14Url, setForm14Url] = useState(null);
  const [InspectionCertificateFileList, setInspectionCertificateFileList] = useState([]);
  const [InspectionCertificateUrl, setInspectionCertificateUrl] = useState(null);
  const [editData, setEditData] = useState(null);
  const fetchVehicleData = async () => {
    if (!idOfVehicle) return;

    try {
      const res = await platformApi.get(`/api/vehicle/${idOfVehicle}`);
      setEditData(res.data.response.data);
    } catch (err) {
      console.error("Unable to fetch vehicle data", err);
    }
  };
  useEffect(() => {
    fetchVehicleData();
  }, [idOfVehicle]);
  useEffect(() => {
    if (!editData) return;

    const getDocsByType = (type) =>
      editData.vehicleDocuments?.filter((doc) => doc.type.toLowerCase() === type.toLowerCase()) || [];

    // Address Proof
    const addressDocs = getDocsByType("addressproof");
    setAddressProofUrl(addressDocs[0]?.url || null);
    setAddressProofFileList(addressDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Chassis
    const chassisDocs = getDocsByType("chassisimpression");
    setChassisUrl(chassisDocs[0]?.url || null);
    setChassisFileList(chassisDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Form22
    const form22Docs = getDocsByType("form22");
    setForm22Url(form22Docs[0]?.url || null);
    setForm22FileList(form22Docs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Form21
    const form21Docs = getDocsByType("form21");
    setForm21Url(form21Docs[0]?.url || null);
    setForm21FileList(form21Docs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Signature
    const signatureDocs = getDocsByType("signature");
    setSignatureUrl(signatureDocs[0]?.url || null);
    setSignatureFileList(signatureDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Pan Card / Form60
    const panDocs = getDocsByType("pancardform60");
    setPanCardForm60Url(panDocs[0]?.url || null);
    setPanCardForm60FileList(panDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Right
    const rightDocs = getDocsByType("right");
    setRightUrl(rightDocs[0]?.url || null);
    setRightFileList(rightDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Left
    const leftDocs = getDocsByType("left");
    setLeftUrl(leftDocs[0]?.url || null);
    setLeftFileList(leftDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Front
    const frontDocs = getDocsByType("front");
    setFrontUrl(frontDocs[0]?.url || null);
    setFrontFileList(frontDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Rear
    const rearDocs = getDocsByType("rear");
    setRearUrl(rearDocs[0]?.url || null);
    setRearFileList(rearDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Invoice
    const invoiceDocs = getDocsByType("invoice");
    setInvoiceUrl(invoiceDocs[0]?.url || null);
    setInvoiceFileList(invoiceDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Disclaimer
    const disclaimerDocs = getDocsByType("disclaimer");
    setDisclaimerUrl(disclaimerDocs[0]?.url || null);
    setDisclaimerFileList(disclaimerDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Form14
    const form14Docs = getDocsByType("form14");
    setForm14Url(form14Docs[0]?.url || null);
    setForm14FileList(form14Docs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

    // Inspection Certificate
    const inspectionDocs = getDocsByType("inspectioncertificate");
    setInspectionCertificateUrl(inspectionDocs[0]?.url || null);
    setInspectionCertificateFileList(inspectionDocs.map(doc => ({
      uid: doc.id,
      name: `${doc.type}`,
      status: "done",
      url: doc.url
    })));

  }, [editData]);


  useEffect(() => {
    platformApi.get("/api/insurance").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setInsurances(response.data);
          for (let item of response.data) {
            insurancePair[item.id] = item.name;
          }
          setInsurancePair(insurancePair);
        }
      }
    });
    setModifyData(insuranceData)
  }, []);

  const columns = [
    {
      title: "Insurer",
      dataIndex: modifyData && modifyData.insurance ? "insurance" : "insurer",
      key: "insurer",
      // render: (record, data) => <span>{record ? insurancePair[record] : data && data.insurance && data.insurance.name}</span>
      render: (record, data) => (
        <span>
          {record
            ? insurancePair[record]
            : data && data.insurance && data.insurance.name}
        </span>
      ),
    },
    {
      title: "Policy No",
      dataIndex: "policyNumber",
      key: "policyNumber",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Type",
      dataIndex: "insuranceType",
      key: "insuranceType",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Valid From",
      dataIndex: "validFrom",
      key: "validFrom",
      render: (record) => <span>{moment(record).format("DD-MM-YYYY")}</span>,
    },
    {
      title: "Valid To",
      dataIndex: "validTo",
      key: "validTo",
      render: (record) => <span>{moment(record).format("DD-MM-YYYY")}</span>,
    },
    {
      title: "Actions",
      render: (record) => (
        <span>
          {record && record.file && record.file.url ? (
            // <a className="linkylink"
            //  download="pdf"
            //  href={record.file.url}
            //  target="_blank"
            // >View</a>
            <a
              className="linkylink"
              // onClick={() => { showUrlPDF(record.file.url) }}
              target="_blank"
              rel="noopener noreferrer"
              href={record.file.url}
            >
              View
            </a>
          ) : (
            <span
              className="linkylink"
              onClick={() => {
                showPDF(record.pdf.file.originFileObj);
              }}
            >
              View
            </span>
          )}

          {editable ? (
            <>
              <Divider type="vertical" />
              <Popconfirm
                title="Are you sure remove this Insurance?"
                okText="Yes"
                cancelText="No"
                onCancel={(event) => {
                  event.stopPropagation();
                }}
                onConfirm={(event) => {
                  if (record && record.id) {
                    // removeData(data)
                    // alert("Old Data")
                    event.stopPropagation();
                    // removedData.push(record)
                    setRemovedData([...removedData, record]);
                    removeInsurance(record);
                  } else {
                    event.stopPropagation();
                    removeInsurance(record);
                  }
                }}
              >
                <span
                  className="linkylink"
                  onClick={(event) => event.stopPropagation()}
                >
                  <Icon style={{ marginLeft: "0.5rem" }} component={minimize} />
                </span>
              </Popconfirm>
            </>
          ) : null}
        </span>
      ),
    },
  ];

  // const normFile = (e) => {
  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   return e && e.fileList;
  // };

  const handleUpload = (info) => {
    if (info.file.status === "uploading") {
      let files = [...info.fileList];
      setFileList(files.slice(-1));
      setPdf(true);
      setUploading(true);
    }
    if (info.file.status === "done") {
      setPdf(false);
      setUploading(false);
      // formData.append("profile", info.file);
      formData.append("module", "Vehicle");
      formData.append("master", "Transaction Master");
      if (editable) {
        formData.append("type", "Insurance-Update");
      } else {
        formData.append("type", "Insurance");
      }
      formData.append(dataSource.length - 1, info.file.originFileObj);
      // platformApi
      //   .post("/api/upload/", formData, {
      //     headers: { "Content-Type": "multipart/form-data" },
      //   })
      //   .then((res) => {
      //     let { data } = res;
      //     if (data.code === 200) {
      //       // data.rear = data.data.Location;
      //       setImageUrl(data.response.data.Location);
      //     } else {
      //       message.error("Upload Not Done");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error on Observation Form : ", error);
      //     message("Unable to upload image");
      //   });

      addInsurance();
    }
  };

  useEffect(() => {
    if (modifyData && modifyData.length > 0) {
      setNewData((prev) => ([...prev, ...modifyData]));
    }
  }, [modifyData]);

  const handleDelete = (data) => {
    let filteredData = fileList.filter((item) => {
      return item !== data;
    });
    setFileList(filteredData);
    setFieldsValue({ pdf: undefined });
  };
  useEffect(() => {
    if (fileList.length === 0) {
      setFieldsValue({ pdf: undefined });
    }
  }, [fileList]);

  const getBase64 = (pdf, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(pdf);
  };

  const showPDF = (data) => {
    getBase64(data, (url) => {
      // var fileURL = URL.createObjectURL(url);
      // window.open(fileURL)
      // setUrl(url)
      setPDFdata(data);
      let pdfWindow = window.open("");
      pdfWindow.document.write(
        "<title>" +
        data.name +
        '</title><iframe type="application/pdf"  frameBorder="0"  width="100%" height="100%" title="' +
        data.name +
        '" src="' +
        url +
        '"></iframe>'
      );
      // setVisiblePDF(true)
    });
  };

  const clearFields = () => {
    form.resetFields();
    setFileList([]);
    // document.querySelector('.anticon-delete').click()
    // setFieldsValue({pdf:null})
  };

  const removeInsurance = (data) => {
    if (data.id) {
      // alert("olddata")
      let filteredAry = newData.filter(function (e) {
        return e !== data;
      });
      setNewData(filteredAry);
    } else {
      formData.delete(dataSource.indexOf(data));
      var filteredAry = dataSource.filter(function (e) {
        return e !== data;
      });
      setDataSource(filteredAry);
      setData(filteredAry);
      setFormDataList(filteredAry);
    }
  };

  const handleBulkUpload = (file) => {
    const tempId = `${Date.now()}-${file.uid}`;
    const pendingItem = {
      tempId,
      file,
      insurer: undefined,
      policyNumber: "",
      insuranceType: "",
      validFrom: null,
      validTo: null,
      parsing: true,
    };

    setBulkUploads((prev) => [...prev, pendingItem]);
    parseInsuranceDoc(tempId, file);
    return false; // stop Upload from auto posting
  };

  const parseInsuranceDoc = async (tempId, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      // backend should return parsed fields for the uploaded PDF
      const res = await platformApi.post("/api/insurance/parse", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const parsed = res?.data?.response?.data || res?.data?.data || {};
      let insuranceType = parsed.insuranceType || "1+5";

      setBulkUploads((prev) =>
        prev.map((item) =>
          item.tempId === tempId
            ? {
              ...item,
              insurer: parsed.insurerId || item.insurer,
              policyNumber: parsed.policyNumber || item.policyNumber,
              //insuranceType: parsed.insuranceType || item.insuranceType,
              insuranceType: insuranceType,
              validFrom: parsed.validFrom
                ? moment(parsed.validFrom, "DD/MM/YYYY")
                : item.validFrom,
              validTo: parsed.validTo ? moment(parsed.validTo, "DD/MM/YYYY") : item.validTo,
              parsing: false,
            }
            : item
        )
      );
    } catch (err) {
      console.error("Failed to parse insurance doc", err);
      message.error("Could not prefill from document");
      setBulkUploads((prev) =>
        prev.map((item) =>
          item.tempId === tempId ? { ...item, parsing: false } : item
        )
      );
    }
  };

  const updateBulkField = (tempId, key, value) => {
    setBulkUploads((prev) =>
      prev.map((item) =>
        item.tempId === tempId
          ? {
            ...item,
            [key]: value,
          }
          : item
      )
    );
  };

  const removeBulkItem = (tempId) => {
    setBulkUploads((prev) => prev.filter((item) => item.tempId !== tempId));
  };

  const saveBulkItem = (item) => {
    const { insurer, policyNumber, insuranceType, validFrom, validTo, file } =
      item;

    if (item.parsing) {
      message.info("Parsing document... please wait");
      return;
    }

    if (
      !insurer ||
      !policyNumber ||
      !insuranceType ||
      !validFrom ||
      !validTo ||
      !file
    ) {
      message.warning("Fill all fields for this upload before saving");
      return;
    }

    if (!moment(validFrom).isSameOrBefore(moment(validTo), "day")) {
      message.error("Valid From date must be on or before Valid To date");
      return;
    }

    const duplicate =
      dataSource.some(
        (row) =>
          row.insurer === insurer || row.policyNumber === policyNumber
      ) ||
      newData.some(
        (row) =>
          row.insurance?.id === insurer || row.policyNumber === policyNumber
      );

    if (duplicate) {
      message.warning("Duplicate insurer or policy number");
      return;
    }

    const data = {
      id: "",
      insurer,
      policyNumber,
      insuranceType,
      validFrom: moment(validFrom),
      validTo: moment(validTo),
      pdf: { file: { originFileObj: file } },
      url: null,
    };

    const nextIndex = dataSource.length;
    formData.append(nextIndex, file);
    setDataSource((prev) => [...prev, data]);
    setFormDataList((prev) => [...prev, data]);
    setNewData((prev) => [...prev, data]);
    setBulkUploads((prev) => prev.filter((row) => row.tempId !== item.tempId));
  };
  const addInsurance = () => {
    validateFields((err) => {
      if (!err) {
        platformApi.post("/api/insurance", insuranceData).then((res) => {
          const savedInsurance = res.data.response;
          setFormData({ ...formData, id: savedInsurance.id });
        });
      }
      if (err === null) {
        let valid = true;
        let error;
        // if(editable){
        //     for (let item of modifyData){
        //       let { insurance,policyNumber } = item
        //       if (insurance.id == getFieldValue('insurer')) {
        //         error = 'This Insurance Name is already uploaded'
        //         valid = false
        //       }
        //       else if (policyNumber == getFieldValue('policyNumber')) {
        //         error = 'This Policy number is already uploaded'
        //         valid = false
        //       }

        //     }
        // }
        // for (let item of dataSource) {
        //   let { insurer, policyNumber } = item
        //   if (insurer == getFieldValue('insurer')) {
        //     error = 'This Insurance Name is already added'
        //     setFieldsValue({ "pdf": undefined })
        //     setFieldsValue({insurer:''})
        //     valid = false
        //   }
        //   else if (policyNumber == getFieldValue('policyNumber')) {
        //     error = 'This Policy number is already added'
        //     setFieldsValue({ "pdf": undefined })
        //     setFieldsValue({policyNumber:''})
        //     valid = false
        //   }
        // }
        // for (let item of newData) {
        //   let { insurance, policyNumber } = item
        //   if (insurance.id == getFieldValue('insurer')) {
        //     error = 'This Insurance Name is already added'
        //     setFieldsValue({ "pdf": undefined })
        //     // setFileList([])
        //     setFieldsValue({insurer:''})
        //     valid = false
        //   }
        //   else if (policyNumber == getFieldValue('policyNumber')) {
        //     error = 'This Policy number is already added'
        //     setFieldsValue({ "pdf": undefined })
        //     // setFileList([])
        //     setFieldsValue({policyNumber:''})
        //     valid = false
        //   }
        // }

        if (valid) {
          const validFromDate = getFieldValue("validFrom");
          const validToDate = getFieldValue("validTo");

          if (!moment(validFromDate).isSameOrBefore(moment(validToDate), "day")) {
            message.error("Valid From date must be on or before Valid To date");
            return;
          }

          let from = moment(new Date(validFromDate)).format("DD-MM-YYYY");
          let to = moment(new Date(validToDate)).format("DD-MM-YYYY");

          let data = {
            id: "",
            insurer: getFieldValue("insurer"),
            policyNumber: getFieldValue("policyNumber"),
            insuranceType: getFieldValue("insuranceType"),
            validFrom: moment(validFromDate._d),
            validTo: moment(validToDate._d),
            pdf: getFieldValue("pdf"),
            url: imageUrl,
          };

          setDataSource((prev) => ([...prev, data]));
          setModifyData([data])
          //Storing form data inside a list
          setFormDataList([...insuranceData, data]);

          //Pushing data in normal list
          // const dataSources = [...dataSource, data]
          // dataSource.push(data);
          setFileList([]);
          form.resetFields();
        } else {
          message.error("insurance error : ", error);
        }
      }
    });
  };

  const onOk = () => {
    if (dataSource.length == 0) {
      message.error("Add a insurance data before submit!!!");
    } else {
      formData.append("module", "Vehicle");
      formData.append("master", "Transaction Master");
      if (editable) {
        formData.append("type", "Insurance-Update");
      } else {
        formData.append("type", "Insurance");
      }
      for (let item of dataSource) {
        formData.append(dataSource.indexOf(item), item.pdf.file.originFileObj);
      }
      setData(formDataList);
      form.resetFields();
      setFileList([]);
      setInsModal(false);
    }
  };

  const clearAll = () => {
    setInsModal(false);
    form.resetFields();
    setFileList([]);
    setData([]);
    for (let i = 0; i < dataSource.length; i++) {
      formData.delete(i);
    }
    setDataSource([]);
  };

  const searchInsurance = (search) => {
    // let data = { module: 'partsMasters', size: 100, column: 'number', fields: ['number', 'name'], searchString: e }
    platformApi
      .post("/api/options/get", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        searchColumns: search.searchColumns,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          search.setValue(data.response);
        }
      })
      .catch((err) => {
        console.error("Part Fetch Error: ", err);
        message.error("Couldn't Fetch Parts");
      });
  };

  useEffect(() => {
    if (getFieldValue("insurer") && getFieldValue("insurer").length > 0) {
      setRequired(true);
    } else {
      setRequired(false);
    }
  }, [getFieldValue("insurer")]);

  const checkInsurance = (data) => {
    let error = "";
    for (let item of dataSource) {
      let { insurer, policyNumber } = item;
      if (insurer === getFieldValue("insurer")) {
        error = "This Insurance Name is already added";
        setFieldsValue({ pdf: undefined });
        setFieldsValue({ insurer: undefined });
        // error = ""
        // valid = false
      }
    }
    for (let item of newData) {
      let { insurance, policyNumber } = item;
      if (insurance.id === getFieldValue("insurer")) {
        error = "This Insurance Name is already added";
        setFieldsValue({ pdf: undefined });
        // setFileList([])
        setFieldsValue({ insurer: undefined });
        // valid = false
      }
    }
    if (error.length > 0) {
      message.warning(error);
    }
  };

  return (
    // <Modal
    //   wrapClassName="insurance-form"
    //   title="Add Insurance"
    //   visible={insModal}
    //   onOk={() => onOk()}
    //   okText="Save"
    //   okButtonProps={{ disabled: dataSource.length === 0 ? true : false }}
    //   onCancel={() => { clearAll() }}
    // >
    <>
      <Form>
        <h3>Adding New Insurance Docs:</h3>
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Table
              dataSource={
                modifyData && Object.keys(modifyData).length > 0
                  ? newData
                  : dataSource
              }
              columns={columns}
            />
          </Col>
        </Row>
        <Divider />
        {editable ? (
          <>
            <h3>Upload Bulk Insurance</h3>
            <Upload
              beforeUpload={handleBulkUpload}
              fileList={[]}
              multiple
              accept=".pdf"
              showUploadList={false}
            >
              <Button type="primary" ghost>
                <Icon component={upload} /> Upload Bulk Insurance
              </Button>
            </Upload>
            {bulkUploads.length > 0 ? (
              <>
                <Divider />
                {bulkUploads.map((item) => (
                  <div
                    key={item.tempId}
                    style={{
                      border: "1px solid #f0f0f0",
                      padding: "12px",
                      marginBottom: "12px",
                      borderRadius: "6px",
                    }}
                  >
                    <Row type="flex" justify="space-between">
                      <Col span={7}>
                        <Item label="Insurer">
                          <Select
                            placeholder="Insurer"
                            value={item.insurer}
                            showSearch
                            filterOption={(input, option) => {
                              const name = option.props.children;
                              if (!name) return false;
                              return name
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                            }}
                            onChange={(val) =>
                              updateBulkField(item.tempId, "insurer", val)
                            }
                          >
                            {insurances.map((ins) => (
                              <Option value={ins.id} key={ins.id}>
                                {ins.name || "Unnamed Insurer"}
                              </Option>
                            ))}
                          </Select>
                        </Item>
                      </Col>
                      <Col span={7}>
                        <Item label="Policy No">
                          <Input
                            placeholder="Policy Number"
                            value={item.policyNumber}
                            onChange={(e) => {
                              // Allow alphanumeric, hyphens, dots, forward slashes, and spaces
                              const value = e.target.value.replace(/[^a-zA-Z0-9\-./\s]/g, "");
                              updateBulkField(item.tempId, "policyNumber", value);
                            }}
                          />
                        </Item>
                      </Col>
                      <Col span={7}>
                        <Item label="Insurance Type">
                          <Select
                            placeholder="Insurance Type"
                            value={item.insuranceType}
                            onChange={(val) =>
                              updateBulkField(item.tempId, "insuranceType", val)
                            }
                          >
                            <Option value="1+5">1+5</Option>
                            <Option value="5+5">5+5</Option>
                            <Option value="1+5 Zero Dep">1+5 Zero Dep</Option>
                            <Option value="5+5 Zero Dep">5+5 Zero Dep</Option>
                            {/* <Option value="1+1">1+1</Option>
                            <Option value="1+1 Zero Dep">1+1 Zero Dep</Option>
                            <Option value="1 Yr OD">1 Yr OD</Option>
                            <Option value="1 Yr OD Zero Dep">
                              1 Yr OD Zero Dep
                            </Option>
                            <Option value="3rd Party">3rd Party</Option> */}
                          </Select>
                        </Item>
                      </Col>
                    </Row>
                    <Row type="flex" justify="space-between">
                      <Col span={7}>
                        <Item label="Valid From">
                          <DatePicker
                            key={`from-${item.tempId}-${item.validTo ? moment(item.validTo).valueOf() : 'none'}`}
                            format="DD-MM-YYYY"
                            value={item.validFrom ? moment(item.validFrom) : null}
                            disabledDate={(current) => {
                              if (!current || !item.validTo) return false;
                              return current.isAfter(moment(item.validTo), "day");
                            }
                            }
                            onChange={(val) =>
                              updateBulkField(item.tempId, "validFrom", val)
                            }
                          />
                        </Item>
                      </Col>
                      <Col span={7}>
                        <Item label="Valid To">
                          <DatePicker
                            key={`to-${item.tempId}-${item.validFrom ? moment(item.validFrom).valueOf() : 'none'}`}
                            format="DD-MM-YYYY"
                            value={item.validTo ? moment(item.validTo) : null}
                            disabledDate={(current) => {
                              if (!current || !item.validFrom) return false;
                              return current.isBefore(moment(item.validFrom), "day");
                            }
                            }
                            onChange={(val) =>
                              updateBulkField(item.tempId, "validTo", val)
                            }
                          />
                        </Item>
                      </Col>
                      <Col span={7} style={{ display: "flex", alignItems: "flex-end" }}>
                        <div>
                          <div style={{ marginBottom: "8px" }}>
                            File: <strong>{item.file?.name}</strong>
                          </div>
                          {item.parsing ? (
                            <div style={{ color: "#999", marginBottom: 8 }}>
                              Prefilling from document...
                            </div>
                          ) : null}
                          <Button
                            type="primary"
                            onClick={() => saveBulkItem(item)}
                            disabled={item.parsing}
                            style={{ marginRight: 8 }}
                          >
                            Save
                          </Button>
                          <Button onClick={() => removeBulkItem(item.tempId)}>
                            Remove
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            ) : null}
          </>
        ) : null}
        {/* <Divider /> */}
        {editable ? (
          <>
            <Row type="flex" justify="space-between">
              <Col span={7}>
                <Item label="Insurer">
                  {getFieldDecorator("insurer", {
                    rules: [{ required: required, message: "Select Insurer" }],
                  })(
                    <Select
                      placeholder="Insurer"
                      showSearch
                      filterOption={null}
                      onSelect={(data) => {
                        checkInsurance(data);
                      }}
                      onSearch={(e) => {
                        const search = {
                          module: "insurances",
                          column: "name",
                          fields: ["name"],
                          searchString: e,
                          searchColumns: ["name"],
                          setValue: setInsurances,
                        };
                        searchInsurance(search);
                      }}
                      allowClear
                    >
                      {insurances.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name || "Unnamed Insurer"}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Item>
              </Col>
              <Col span={7}>
                <Item label="Policy No">
                  {getFieldDecorator("policyNumber", {
                    rules: [
                      { required: required, message: "Enter Policy Number" },
                      {
                        pattern: /^[a-zA-Z0-9\-./\s]+$/,
                        message: "Special characters are not allowed",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Policy No"
                      onKeyUp={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z0-9\-./\s]/g,
                          ""
                        );
                        form.setFieldsValue({ policyNumber: value });
                      }}
                      onInput={(e) => {
                        const value = e.target.value.replace(
                          /[^a-zA-Z0-9\-./\s]/g,
                          ""
                        );
                        form.setFieldsValue({ policyNumber: value });
                      }}
                    />
                  )}
                </Item>
              </Col>
              <Col span={7}>
                <Item label="Insurance Type">
                  {getFieldDecorator("insuranceType", {
                    rules: [
                      { required: required, message: "Select Insurance Type" },
                    ],
                  })(
                    <Select allowClear placeholder="Insurance Type">
                      <Option value="1+5">1+5</Option>
                      <Option value="5+5">5+5</Option>
                      <Option value="1+5 Zero Dep">1+5 Zero Dep</Option>
                      <Option value="5+5 Zero Dep">5+5 Zero Dep</Option>
                      <Option value="1+1">1+1</Option>
                      <Option value="1+1 Zero Dep">1+1 Zero Dep</Option>
                      <Option value="1 Yr OD">1 Yr OD</Option>
                      <Option value="1 Yr OD Zero Dep">1 Yr OD Zero Dep</Option>
                      <Option value="3rd Party">3rd Party</Option>
                    </Select>
                  )}
                </Item>
              </Col>
            </Row>

            <Row type="flex" justify="space-between">
              <Col span={7}>
                <Item label="Valid From">
                  {getFieldDecorator("validFrom", {
                    rules: [
                      { required: required, message: "Select Valid From Date" },
                    ],
                  })(
                    <DatePicker
                      format="DD-MM-YYYY"
                      disabledDate={(current) => {
                        const validTo = getFieldValue("validTo");
                        if (!current || !validTo) return false;
                        return current.isAfter(validTo, "day");
                      }}
                      placeholder="Valid From"
                    />
                  )}
                </Item>
              </Col>
              <Col span={7}>
                <Item label="Valid To">
                  {getFieldDecorator("validTo", {
                    rules: [
                      { required: required, message: "Select Valid To Date" },
                    ],
                  })(
                    <DatePicker
                      format="DD-MM-YYYY"
                      disabledDate={(current) => {
                        const validFrom = getFieldValue("validFrom");
                        if (!current || !validFrom) return false;
                        return current.isBefore(validFrom, "day");
                      }}
                      placeholder="Valid To"
                    />
                  )}
                </Item>
              </Col>
              <Col span={7}>
                <Item label="Documents">
                  {/* rules: [{ required: pdf && getFieldValue('pdf')!=undefined ? false:true, message: "Choose PDF file" }], */}
                  {getFieldDecorator("pdf", {
                    rules: [{ required: required, message: "Choose PDF file" }],
                  })(
                    <Upload
                      action={`${urls}api/upload/mocky`}
                      onChange={handleUpload}
                      onRemove={(data) => handleDelete(data)}
                      fileList={fileList}
                      accept=".pdf"
                    >
                      <Button
                        disabled={
                          getFieldValue("insurer") &&
                            getFieldValue("policyNumber") &&
                            getFieldValue("insuranceType") &&
                            getFieldValue("validFrom") &&
                            getFieldValue("validTo")
                            ? uploading
                              ? true
                              : false
                            : true
                        }
                        type="primary"
                        ghost
                      >
                        <Icon component={upload} /> Upload & Save
                      </Button>
                    </Upload>
                  )}
                </Item>
              </Col>
            </Row>
          </>
        ) : null}


        {/* <Divider /> */}
        {/* <Row>
          <Col style={{ float: 'right', marginTop: "15px" }}>
            <Button style={{ marginRight: '1rem' }} onClick={() => { clearFields() }}>Clear</Button>
            <Button type="primary" disabled={uploading} onClick={() => { addInsurance() }}>Add</Button>
          </Col>
        </Row> */}
      </Form>
      <Divider />
      <h3>Upload Required Documents</h3>

      <Row gutter={[16, 16]}>
        <Col span={6}>
          <label>Address Proof</label>
          <ImageUploader
            type="AddressProof"
            fileList={addressProofFileList}
            setFileList={setAddressProofFileList}
            imageUrl={addressProofUrl}
            setImageUrl={setAddressProofUrl}
            editable={editable}
            id={idOfVehicle}
            //id={formData.id}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>

        <Col span={6}>
          <label>Chassis Impression</label>
          <ImageUploader
            type="ChassisImpression"
            fileList={chassisFileList}
            setFileList={setChassisFileList}
            imageUrl={chassisUrl}
            setImageUrl={setChassisUrl}
            editable={editable}
            id={idOfVehicle}
            setLoading={setUploading}
          />
        </Col>

        <Col span={6}>
          <label>Form 22</label>
          <ImageUploader
            type="Form22"
            fileList={form22FileList}
            setFileList={setForm22FileList}
            imageUrl={form22Url}
            setImageUrl={setForm22Url}
            editable={editable}
            id={idOfVehicle}
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Form 21</label>
          <ImageUploader
            type="Form21"
            fileList={form21FileList}
            setFileList={setForm21FileList}
            imageUrl={form21Url}
            setImageUrl={setForm21Url}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Signature</label>
          <ImageUploader
            type="Signature"
            fileList={SignatureFileList}
            setFileList={setSignatureFileList}
            imageUrl={SignatureUrl}
            setImageUrl={setSignatureUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>PanCard/Form60</label>
          <ImageUploader
            type="PanCardForm60"
            fileList={PanCardForm60FileList}
            setFileList={setPanCardForm60FileList}
            imageUrl={PanCardForm60Url}
            setImageUrl={setPanCardForm60Url}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Right</label>
          <ImageUploader
            type="Right"
            fileList={RightFileList}
            setFileList={setRightFileList}
            imageUrl={RightUrl}
            setImageUrl={setRightUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Left</label>
          <ImageUploader
            type="Left"
            fileList={LeftFileList}
            setFileList={setLeftFileList}
            imageUrl={LeftUrl}
            setImageUrl={setLeftUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Front</label>
          <ImageUploader
            type="Front"
            fileList={FrontFileList}
            setFileList={setFrontFileList}
            imageUrl={FrontUrl}
            setImageUrl={setFrontUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Rear</label>
          <ImageUploader
            type="Rear"
            fileList={RearFileList}
            setFileList={setRearFileList}
            imageUrl={RearUrl}
            setImageUrl={setRearUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Invoice</label>
          <ImageUploader
            type="Invoice"
            fileList={InvoiceFileList}
            setFileList={setInvoiceFileList}
            imageUrl={InvoiceUrl}
            setImageUrl={setInvoiceUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Disclaimer</label>
          <ImageUploader
            type="Disclaimer"
            fileList={DisclaimerFileList}
            setFileList={setDisclaimerFileList}
            imageUrl={DisclaimerUrl}
            setImageUrl={setDisclaimerUrl}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>Form14</label>
          <ImageUploader
            type="Form14"
            fileList={Form14FileList}
            setFileList={setForm14FileList}
            imageUrl={Form14Url}
            setImageUrl={setForm14Url}
            editable={editable}
            id={idOfVehicle}  // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
        <Col span={6}>
          <label>InspectionCertificate</label>
          <ImageUploader
            type="InspectionCertificate"
            fileList={InspectionCertificateFileList}
            setFileList={setInspectionCertificateFileList}
            imageUrl={InspectionCertificateUrl}
            setImageUrl={setInspectionCertificateUrl}
            editable={editable}
            id={idOfVehicle} // pass parent ID if available
            setLoading={setUploading}
          />
        </Col>
      </Row>

      {/* repeat <Row> blocks until all 13 docs are covered */}

      {/* Showing PDF File... */}
      {PDFdata != null ? (
        <Modal
          wrapClassName="pdf-form"
          title={PDFdata.name}
          visible={visiblePDF}
          onCancel={() => {
            setVisiblePDF(false);
            setUrl(null);
          }}
          footer={null}
        >
          <Row>
            <Col>
              {/* <a href={url}>click</a> */}
              <iframe
                type="application/pdf"
                target="_blank"
                frameBorder="0"
                style={{
                  border: "none",
                  width: "100%",
                  height: "25rem",
                  padding: "10%",
                }}
                title={PDFdata.name}
                src={url}
              ></iframe>
            </Col>
          </Row>
        </Modal>
      ) : (
        <span></span>
      )}
      {/* </Modal> */}
    </>
  );
};

const WrappedInsuranceForm = Form.create()(InsuranceForm);

export default WrappedInsuranceForm;
